import { useLocation } from "react-router-dom";
import { useContact } from "@utils/hooks";

const env = import.meta.env as Record<string, string | undefined>;

const BENEFICIARY_PORTAL_URL =
  env.VITE_NEW_BENEFICIARY_PORTAL_URL ||
  env.NEW_BENEFICIARY_PORTAL_URL ||
  "https://dashboard.plymouthstreet.com/onboarding_portal/dashboard";
const EMPLOYER_PORTAL_URL =
  env.VITE_NEW_PETITIONER_PORTAL_URL ||
  env.NEW_PETITIONER_PORTAL_URL ||
  "https://dashboard.plymouthstreet.com/onboarding_portal/employer/employees";

const RelocatedPage = () => {
  const location = useLocation();
  const { team } = useContact();

  const pathname = location.pathname.toLowerCase();
  const isEmployerPath = pathname.includes("employer");
  const isBeneficiaryPath = pathname.includes("beneficiary");
  const isEmployerTeam = team?.type === "team";

  const destinationUrl = isEmployerPath
    ? EMPLOYER_PORTAL_URL
    : isBeneficiaryPath
      ? BENEFICIARY_PORTAL_URL
      : isEmployerTeam
        ? EMPLOYER_PORTAL_URL
        : BENEFICIARY_PORTAL_URL;

  const destinationLabel = destinationUrl === EMPLOYER_PORTAL_URL
    ? "Go to New Employer Portal"
    : "Go to new beneficiary portal";

  return (
    <div className="w-full h-full min-h-screen bg-gray-50 p-6">
      <div className="max-w-3xl mx-auto mt-8">
        <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-8">
          <h1 className="text-2xl font-semibold text-gray-900 mb-3">
            We have relocated to a new and improved portal!
          </h1>
          <p className="text-gray-700 text-base leading-7">
            Please click the link below to be redirected to your new dashboard.
          </p>
          <div className="mt-6">
            <a
              href={destinationUrl}
              className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-blue-600 text-white no-underline hover:bg-blue-700 transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              {destinationLabel}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RelocatedPage;
